import React from "react";

const SmallStarIcon = () => {
	return (
		<span>
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M6.7088 4.11306C7.25596 2.70435 7.52954 2 8 2C8.47046 2 8.74404 2.70436 9.29121 4.11307L9.31668 4.17866C9.62581 4.97451 9.78037 5.37244 10.0954 5.61431C10.4104 5.85617 10.8239 5.89441 11.6509 5.9709L11.8004 5.98473C13.1539 6.10992 13.8307 6.17251 13.9755 6.61716C14.1203 7.06182 13.6177 7.53403 12.6125 8.47845L12.2771 8.79365C11.7682 9.27174 11.5138 9.51078 11.3952 9.82408C11.3731 9.88252 11.3547 9.9424 11.3402 10.0033C11.2622 10.3299 11.3367 10.6767 11.4857 11.3703L11.5321 11.5861C11.806 12.8608 11.9429 13.4981 11.7038 13.773C11.6145 13.8757 11.4984 13.9496 11.3694 13.986C11.0242 14.0833 10.5342 13.6709 9.55412 12.8461C8.91057 12.3046 8.58879 12.0338 8.21936 11.9729C8.07404 11.9489 7.92596 11.9489 7.78064 11.9729C7.41121 12.0338 7.08943 12.3046 6.44588 12.8461C5.4658 13.6709 4.97576 14.0833 4.6306 13.986C4.50163 13.9496 4.38552 13.8757 4.29619 13.773C4.05712 13.4981 4.19405 12.8608 4.46789 11.5861L4.51427 11.3703C4.66327 10.6767 4.73777 10.3299 4.65983 10.0033C4.64529 9.9424 4.6269 9.88252 4.60478 9.82408C4.4862 9.51078 4.23178 9.27174 3.72294 8.79365L3.38746 8.47845C2.38228 7.53403 1.87969 7.06182 2.0245 6.61716C2.16931 6.17251 2.84607 6.10992 4.19959 5.98473L4.3491 5.9709C5.17612 5.89441 5.58962 5.85617 5.90463 5.61431C6.21963 5.37244 6.37419 4.97451 6.68332 4.17866L6.7088 4.11306Z"
					fill="#3A393A"
					stroke="#3A393A"
				/>
			</svg>
		</span>
	);
};

export default SmallStarIcon;
